/**
 * @generated SignedSource<<e377158eb1194128989e3f8147a51296>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateReactionInput = {
  messageId: string;
  reaction: any;
};
export type MessageReactions_chat_createReaction_Mutation$variables = {
  input: CreateReactionInput;
};
export type MessageReactions_chat_createReaction_Mutation$data = {
  readonly createReaction: {
    readonly id: string;
    readonly message: {
      readonly " $fragmentSpreads": FragmentRefs<"MessageReactions_chat_messageFragment">;
    } | null;
  };
};
export type MessageReactions_chat_createReaction_Mutation = {
  response: MessageReactions_chat_createReaction_Mutation$data;
  variables: MessageReactions_chat_createReaction_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageReactions_chat_createReaction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createReaction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Message",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MessageReactions_chat_messageFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageReactions_chat_createReaction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createReaction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Message",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsConnection",
                "kind": "LinkedField",
                "name": "reactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReactionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "senderId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletedAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "259e28e50a84d0242df72f4e806cbabc",
    "id": null,
    "metadata": {},
    "name": "MessageReactions_chat_createReaction_Mutation",
    "operationKind": "mutation",
    "text": "mutation MessageReactions_chat_createReaction_Mutation(\n  $input: CreateReactionInput!\n) {\n  createReaction(input: $input) {\n    id\n    message {\n      ...MessageReactions_chat_messageFragment\n      id\n    }\n  }\n}\n\nfragment MessageReactions_chat_messageFragment on Message {\n  id\n  ...ReactionButton_chat_messageFragment\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment ReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d665fc93a25d6c8acb01fa61b503ac1";

export default node;
